import React, { useMemo } from 'react'
import { CardSuitType, CardValueType } from 'mvppoker-portal-common/api'
import { CardModelUtils } from 'mvppoker-portal-common/model/CardModelUtils'
import { MVPButton } from '../../Buttons/MVPButton'
import decks from '../../../config/decks.json'
import { PokerCardView } from '../../../Pages/Game/components/PokerCard/PokerCardView'
import { classNames } from '../../../utils/cssUtils'
import './SelectDeckModal.scss'

const CARDS_TO_SHOW = [
	{ suit: CardSuitType.Hearts, value: CardValueType.Ace },
	{ suit: CardSuitType.Spades, value: CardValueType.King },
	{ suit: CardSuitType.Diamonds, value: CardValueType.Two },
	{ suit: CardSuitType.Clubs, value: CardValueType.Ten },
]

const DeckButton = ({ deck, name, isSelected, clickDeck }: { deck: number, name: string, isSelected: boolean, clickDeck: (deck: number) => void }) =>
{
	const cs = classNames('deck-button', {
		'is-selected': isSelected,
	})

	const cardViews = useMemo(() => {
		return CARDS_TO_SHOW.map((it) => <PokerCardView deck={deck} card={it} key={CardModelUtils.GetDisplay(it)} />)
	}, [deck])

	return (
		<button className={cs} type='button' onClick={() => clickDeck(deck)}>
			<span>{name}</span>
			<div className='deck-preview'>{cardViews}</div>
		</button>
	)
}

export interface SelectDeckModalViewProps
{
	preferredDeck: number
	clickDeck: (deck: number) => void
	clickClose: () => void
}

export const SelectDeckModalView : React.FC<SelectDeckModalViewProps> = ({ preferredDeck, clickDeck, clickClose }) =>
{
	const buttons = useMemo(() => {
		return decks.map((deck, index) => <DeckButton key={deck} deck={index} name={decks[index]} isSelected={preferredDeck === index} clickDeck={clickDeck} />)
	}, [decks, preferredDeck])

	return (
		<>
			<span className='modal-title-l'>Select Deck</span>
			<div className='button-group'>{buttons}</div>
			<MVPButton className='is-confirm clear' onClick={clickClose}>
				Confirm
			</MVPButton>
		</>
	)
}